// extracted by mini-css-extract-plugin
export default {"link":"locationFilterNote_link__ySJPA","alert":"locationFilterNote_alert__sB2Ix"};